// @ts-ignore
import UTNLogo from "../img/utn-logo-full.png";

export default function Logo(props) {
  return <img {...props} src={UTNLogo} alt="utn-logo" />;
}
